import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

/**
 * The visible card on the sign-in page. The wrapper page handles
 * useForm + post; this component is purely presentational so the
 * help centre can render it as a "screenshot" without wiring up
 * Inertia state.
 *
 * Props (all optional — uncontrolled by default):
 *   email, onEmailChange, processing, errorMessage, errorEmail, onSubmit
 */
export default function SignInCard({
  email = "",
  onEmailChange,
  processing = false,
  errorMessage,
  errorEmail,
  onSubmit,
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle as="h1">Sign in</CardTitle>
        <CardDescription>
          Enter your email and we'll send you a link to sign in. There's no password.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {errorMessage && (
          <Alert variant="destructive" className="mb-6">
            <AlertTitle>Couldn't sign in</AlertTitle>
            <AlertDescription>{errorMessage}</AlertDescription>
          </Alert>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              name="email"
              autoComplete="email"
              autoFocus
              required
              value={email}
              onChange={onEmailChange}
              placeholder="you@example.com"
            />
            {errorEmail && <p className="text-sm text-destructive">{errorEmail}</p>}
          </div>

          <Button type="submit" className="w-full" disabled={processing}>
            <Mail className="h-4 w-4" />
            {processing ? "Sending…" : "Send me a sign-in link"}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
